import { ExtractActions, toggleOverlay, track } from '@vfde-fe/sails_core';
import {
    GET_OVERLAY_CONTENT_FAILED,
    OVERLAY_LOADED,
    PRELOAD_GIGAKOMBI_OVERLAY,
    TRACK_OVERLAY,
} from './constant';
import { StateProps } from './interfaces/state';

/** Getting the content of the overlay failed
 */
const getOverlayContentFailed = (error: unknown) => ({
    type: GET_OVERLAY_CONTENT_FAILED,
    error,
});

/**
 * setOverlayMounted
 */
const preloadGigaKombiOverlay = (contentTarget: HTMLElement, scriptTarget: HTMLElement) => ({
    type: PRELOAD_GIGAKOMBI_OVERLAY,
    contentTarget,
    scriptTarget,
});

/**
 * setOverlayMounted
 */
const overlayLoaded = () => ({
    type: OVERLAY_LOADED,
});

/**
 * trackOverlay
 * @param newState
 */
const trackOverlay = (newState: StateProps) => {
    const { overlayState, overlayName } = newState;
    const action = {
        type: TRACK_OVERLAY,
    };
    const payload = {
        action: overlayState ? 'show' : 'close',
        name: overlayName,
    };

    return track<typeof action, typeof payload>(action, 'layover', payload);
};

/**
 * Action Creators Object
 */
export const overlayActionCreators = {
    getOverlayContentFailed,
    preloadGigaKombiOverlay,
    overlayLoaded,
    trackOverlay,
};

/**
 * Action Dispatchers Object
 */
export const overlayActionDispatchers = {
    toggleOverlay,
    trackOverlay,
    preloadGigaKombiOverlay,
};

/**
 * Action Creators
 */
export type OverlayActionCreators = typeof overlayActionCreators;

/**
 * Action Dispatchers
 */
export type OverlayActionDispatchers = typeof overlayActionDispatchers;

/**
 * Union Action Type
 */
export type OverlayAction = ExtractActions<OverlayActionCreators>;
